/**
 * Mutable runtime workspace (portfolio + org).
 * API helpers (requireConfig) read from here so org can change without rebuild.
 */

const ORG_STORAGE_KEY = 'arbitiumdemo.org';

function readStoredOrg(): string {
  try {
    return (localStorage.getItem(ORG_STORAGE_KEY) || '').trim();
  } catch {
    return '';
  }
}

function readEnv(key: string): string {
  const v = process.env[key];
  return typeof v === 'string' ? v.trim() : '';
}

let portfolio = readEnv('REACT_APP_PORTFOLIO');
/** Prefer persisted org; REACT_APP_ORG is legacy fallback only. */
let org = readStoredOrg() || readEnv('REACT_APP_ORG');

type Listener = () => void;
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach((l) => l());
}

export function getWorkspace(): { portfolio: string; org: string } {
  return { portfolio, org };
}

export function setPortfolio(portfolioId: string) {
  const next = (portfolioId || '').trim();
  if (next === portfolio) return;
  portfolio = next;
  notify();
}

export function setOrg(orgId: string) {
  const next = (orgId || '').trim();
  if (next === org) return;
  org = next;
  try {
    if (next) localStorage.setItem(ORG_STORAGE_KEY, next);
    else localStorage.removeItem(ORG_STORAGE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
  notify();
}

export function subscribeWorkspace(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
